/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, array, string, func, shape, arrayOf, number, bool,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CreateIcon from '@material-ui/icons/Create';
import Button from '@material-ui/core/Button';

import configENV from '../../../config';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import { combineStyle } from '../../../style/combineStyle';
import { innerModal as InnerModalStyle } from '../../../style/innerModal';
import { deepObjectExtend } from '../../../utils/object';
import { main as MainStyle } from '../../../style/main';
import { form as FormStyle } from '../../../style/form';
import DesktopCardInfo from './DesktopCardInfo';
import AccountLeftMenu from '../../../common/Desktop/AccountLeftMenu';
import VIsmallcard from '../../../assets/svg/VIsmallcard';
import MCsmallcard from '../../../assets/svg/MCsmallcard';
import AXsmallcard from '../../../assets/svg/AXsmallcard';
import DSsmallcard from '../../../assets/svg/DSsmallcard';
import PYsmallcard from '../../../assets/svg/PYsmallcard';
import APsmallcard from '../../../assets/svg/APsmallcard';
import GPsmallcard from '../../../assets/svg/GPsmallcard';
import VMsmallcard from '../../../assets/svg/VMsmallcard';

const { PERSIST_KEY } = configENV;
const cardIcons = {
    VI: VIsmallcard, // Visa card
    MC: MCsmallcard, // Master card
    AX: AXsmallcard, // Amex card
    DS: DSsmallcard, // Discover card
    PY: PYsmallcard, // PayPal
    AP: APsmallcard, // Apple Pay
    GP: GPsmallcard, // Google Pay
    VM: VMsmallcard, // Venmo
};

const styles = ({ typography, palette }) => deepObjectExtend(
    combineStyle(typography, palette, {
        MainStyle,
        InnerModalStyle,
        FormStyle,
    }),
    {
        rowBorder: {
            width: '100%',
            border: '1px solid #EDEDEA', // TO DO
            display: 'table',
            tableLayout: 'fixed',
            borderRight: '0px',
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            textAlign: 'left',
            '& thead': {
                display: 'table',
                width: '100%',
                tableLayout: 'fixed',
            },
            '& tbody': {
                display: 'block',
                overflowY: 'auto',
                boxShadow: '0px 0px 10px rgb(47 47 47 / 25%)',
            },
            '& tr.default-card': {
                backgroundColor: '#EDEDEA', // TODO
            },
            '& th:first-child, & td:first-child': {
                paddingLeft: '24px',
            },
            '& th:last-child, & td:last-child': {
                width: '200px',
            },
            '& th, & td': {
                padding: '12px',
            },
            '& th': {
                color: '#7C7C7D', // TO DO
                fontSize: '16px',
                fontWeight: 'normal',
            },
        },
        cardNameWrapper: {
            position: 'relative',
        },
        cardIcon: {
            display: 'inline-block',
            position: 'absolute',
            top: '8px',
            left: '17px',
            // Used contains Mui class name to avoid CSS issue on Account MFE
            '& [class*="MuiSvgIcon-root"]': {
                width: '1.3em',
            },

        },
        cardName: {
            display: 'inline-block',
            paddingLeft: '36px',
        },
        actionField: {
            color: '#4A90E2 !important', // TO DO
        },
        footNote: {
            color: '#989797', // TODO
            'font-size': 'small', // TODO
            margin: '20px', // TODO
        },
    },
);

class DesktopBillingInfo extends React.Component {
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount = () => {
      const { handleSetDefaultBillingValue } = this.props;
      handleSetDefaultBillingValue();
  };

  getCardTypeById = (cardTypes, id) => {
      let cardTypeName = null;
      if (cardTypes) {
          const listCardType = cardTypes.filter((c) => c.id === id) || [];
          if (listCardType.length) {
              cardTypeName = listCardType[0].name;
          }
      }
      return cardTypeName;
  }

  renderTableData = (w, defaultCreditCard, i) => {
      const {
          cardTypes, classes, billingAddress, countries, handleClickEditCreditCard,
      } = this.props;
      const paymentMethod = w.payType === 'CC' ? w.cardType : w.payType; // to use payType for payment methods other than CC
      const IconType = cardIcons[paymentMethod];
      const [cardMonth, cardYear] = w.expiryDate.split('/');
      const currentDate = new Date();
      const cardDate = new Date(`20${cardYear}`, Number(cardMonth) - 1);
      const isExpired = !(cardDate - currentDate > 0);
      let cardIndicator = w.subsIndicator === '1' ? <b>Default *</b> : '';
      cardIndicator = isExpired ? <span className="red-color">Expired</span> : cardIndicator;
      const walletAndBillingInfo = {
          ...w, defaultCreditCard: defaultCreditCard[0], billingAddress, countries,
      };

      return (
          <tr key={i} className={`${classes.rowBorder} ${w.subsIndicator === '1' ? 'default-card' : ''}`}>
              <td className={classes.cardNameWrapper}>
                  <span className={classes.cardIcon}>{IconType ? <IconType /> : ''}</span>
                  <span className={classes.cardName}>{this.getCardTypeById(cardTypes, paymentMethod)}</span>
              </td>
              <td>
                  {' '}
                  &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
                  {w.lastFourDigits}
              </td>
              <td>{w.expiryDate}</td>
              <td>{cardIndicator}</td>
              <td className={classes.actionField}>
                  {w.payType === 'CC'
                    && (
                        <span aria-hidden className="link-button" onClick={() => handleClickEditCreditCard(walletAndBillingInfo, 'desktop')}>
                            <CreateIcon className="link-icon" />
                            <span className="link-label">Edit</span>
                        </span>
                    )}
              </td>
          </tr>
      );
  };

  renderTableHeader = () => {
      const {
          classes, wallet, billingAddress, countries, handleClickEditCreditCard,
      } = this.props;
      const defaultCreditCard = wallet.filter((w) => w.subsIndicator === '1');
      const walletAndBillingInfo = { defaultCreditCard: defaultCreditCard[0], billingAddress, countries };
      return (
          <tr>
              <th>Payment Type</th>
              <th>Account Number</th>
              <th>Expiration Date</th>
              <th>Status</th>
              <th className={classes.actionField}>
                  <span aria-hidden className="link-button" onClick={() => handleClickEditCreditCard(walletAndBillingInfo, 'desktop')}>
                      <AddCircleIcon className="link-icon" />
                      <span className="link-label">Add Payment Type</span>
                  </span>
              </th>
          </tr>
      );
  };

  render() {
      const {
          classes,
          userProfile,
          featureFlags,
          wallet,
          addForm,
          billingAddress,
          countries,
          handleClickEditCreditCard,
      } = this.props;
      const defaultCreditCard = wallet.filter((w) => w.subsIndicator === '1');
      const walletAndBillingInfo = { defaultCreditCard: defaultCreditCard[0], billingAddress, countries };
      return (
          <div className="container">
              <Grid container>
                  <AccountLeftMenu
                      userProfile={userProfile}
                      featureFlags={featureFlags}
                  />
                  <Grid item xs={10} style={{ padding: '40px 11px 0 43px' }}>
                      {addForm === 'EditCardInfo' ? (
                          <DesktopCardInfo
                              billingAddress={billingAddress}
                              countries={countries}
                          />
                      ) : (
                          <div>
                              {wallet.length === 0
                                  ? (
                                      <>
                                          <h2>Payment &amp; Billing</h2>
                                          <div className="align-center">
                                              <div className="bold">You do not have any cards stored.</div>
                                              <div className="margin-top-2x">
                                                  <Button
                                                      className="display-inline-block float-none"
                                                      onClick={() => handleClickEditCreditCard(walletAndBillingInfo, 'desktop')}
                                                  >
                                                      Add New Card
                                                  </Button>
                                              </div>
                                          </div>
                                      </>
                                  )
                                  :                              (
                                      <>
                                          <h2>Payment &amp; Billing</h2>
                                          <table className={classes.table}>
                                              <thead>{this.renderTableHeader()}</thead>
                                              <tbody>
                                                  {wallet.map((w, i) => this.renderTableData(w, defaultCreditCard, i))}
                                              </tbody>
                                          </table>
                                          <div className={classes.footNote}>* Use this for Subsciptions &amp; Passport membership</div>
                                      </>
                                  )}
                          </div>
                      )}
                  </Grid>
              </Grid>
          </div>

      );
  }
}
DesktopBillingInfo.defaultProps = {
    addForm: '',
};

DesktopBillingInfo.propTypes = {
    classes: object.isRequired,
    featureFlags: object.isRequired,
    userProfile: shape({
        userRole: string,
    }).isRequired,
    wallet: arrayOf(
        shape({
            walletId: string.isRequired,
            cardType: string.isRequired,
            payType: string.isRequired,
            cardHolderName: string.isRequired,
            cardNumber: string.isRequired,
            lastFourDigits: string.isRequired,
            expiryDate: string.isRequired,
            status: string,
            subsIndicator: string,
            defaultCreditCard: object,
            billingAddress: array,
            countries: array,
        }),
    ).isRequired,
    // constant pages/state/constants/CreditCardTypes.js
    cardTypes: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ).isRequired,
    addForm: string,
    billingAddress: arrayOf(
        shape({
            AddressBookEntryId: string,
            ContactId: number,
            FirstName: string,
            LastName: string,
            RelationShip: string,
            NickName: string,
            LastUpdateDate: string,
            PhoneNumber: string,
            EmployerName: string,
            NumberOfAddresses: number,
            Addresses: arrayOf(
                shape({
                    AddressId: number,
                    AddressBookEntryId: string,
                    AddressType: string,
                    AddressLineOne: string,
                    AddressLineTwo: string,
                    City: string,
                    StateProvince: string,
                    PostalCode: string,
                    Country: string,
                    IsPartialMatch: bool,
                    IsUnknownAddress: bool,
                    Latitude_degrees: number,
                    Longitude_degrees: number,
                    IsBillingAddress: bool,
                    ContactId: number,
                }),
            ),
        }),
    ).isRequired,
    countries: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ).isRequired,
    handleClickEditCreditCard: func.isRequired,
    handleSetDefaultBillingValue: func.isRequired,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isFetchingModal: newState.isFetchingModal,
        modal: newState.modal,
        addForm: newState.addForm,
        pageData: newState.pageData,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleClickEditCreditCard: (walletAndBillingInfo, template) => dispatch(EventDispatcher.handleClickEditCreditCard(walletAndBillingInfo, template)),
    handleSetDefaultBillingValue: () => dispatch(EventDispatcher.handleSetDefaultBillingValue()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(DesktopBillingInfo)));
